import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import EditGrid from '../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { GridColumns } from './GridColumns';
import { getRoles } from '../Authorization/apiRequestService';
import {getUsers} from '../NewProcess/apiRequestService';


class Authorization extends Component {
    constructor(props) {
      super(props);
      this.state = {
        gridFunc:null,
        gridColumns : GridColumns,
        CRUDServices:{
          Create:apiDashBoardService.createAuthorization,
          Update:apiDashBoardService.updateAuthorization,
          Delete:apiDashBoardService.deleteAuthorizationById}
      };
    }
    refreshList(){
       apiDashBoardService.getAuthorizations()
      .then((response) => {
        this.state.gridColumns.filter(item => item.field=="user").map((item) =>{
        if(response.data!=undefined && response.data.length>0)
            this.afterDataLoaded(item,response.data);
          });

        this.gridFunc.state.gridRows= response.data;
        this.gridFunc.state.gridColumns= this.state.gridColumns;
        this.gridFunc.state.columnVisibilityModel= {id:false};
    
        this.gridFunc.setState(this.gridFunc.state)
      })
      .catch((exception) => {
        this.props.actions.setNotification("Yetki bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getAuthorizations exception: ' + JSON.stringify(exception));
      });     
    }
    componentDidMount() {
      getRoles()
      .then((response) => {
        this.state.gridColumns.filter(item => item.field=="role").map((item) =>
          item.dataList=response.data);
      })
      .catch((exception) => {
        this.props.actions.setNotification("Yetki rol bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getRoles exception: ' + JSON.stringify(exception));
      }); 
      
      getUsers()
      .then((response) => {
        this.state.gridColumns.filter(item => item.field=="user").map((item) =>
          item.dataList=response.data);
      })
      .catch((exception) => {
        this.props.actions.setNotification("Kullanıcı bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getUsers exception: ' + JSON.stringify(exception));
      });    
      
      this.refreshList();
    }

    afterDataLoaded(currentItem,processData) { 
      let field=currentItem.field;
      let dataList=currentItem.dataList;
      let keyField=currentItem.keyField;
      let valueField=currentItem.valueField;
  
      for (let i = 0; i < processData.length; i++) {   
        for (let y = 0; y < dataList.length; y++) {
          const element = dataList[y];
          if(element[keyField]===processData[i][field][keyField])
            processData[i][field][valueField]=element[valueField];
        }  
      }
   
    }
  
    closeEditPage(ele) {
      this.refreshList();
    }
    
    render() {
      const { CRUDServices } = this.state;

      return (
        <div>
          <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            <BasicPageComponent
              //title='YETKİ AYARLARI'
              //description='Yetki Tanımlama Ekranı'
              children = {
                <ScreenContainer>
              <EditGrid ref={instance => { this.gridFunc = instance; }} dialogTitle="Yetki Ayarları" gridHeight={400} {...this.props} CRUD={CRUDServices} 
              LoadData={(e) => this.closeEditPage(e)}/>
              </ScreenContainer>
              }
            />       
          </div>
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(Authorization);